import { ArsTableBodyCell } from "../interface";
import { isArsTableDataCell } from "./isArsTableDataCell";
import { isArsTableRowGroupCell } from "./isArsTableRowGroupCell";
import { isArsTableRowGroupLabel } from "./isArsTableRowGroupLabel";
import { isArsTableRowOperationCell } from "./isArsTableRowOperationCell";

/**
 * Type guard for ArsTableBodyCell, which can be any of the body cell types in the table.
 *
 * @param obj - The object to check
 * @param isT - A type guard function for the generic type T used in the cell's displayContent and annotationContent
 * @returns - True if the object is an ArsTableBodyCell, false otherwise
 */
export const isArsTableBodyCell = <T = string>(
  obj: unknown,
  isT: (value: unknown) => value is T,
): obj is ArsTableBodyCell<T> =>
  isArsTableDataCell(obj, isT) ||
  isArsTableRowGroupCell(obj, isT) ||
  isArsTableRowGroupLabel(obj, isT) ||
  isArsTableRowOperationCell(obj, isT);
